// ======================================================================
// File Name       : EnterpriseDetailConfirm
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as enterpriseActions from '../../actions/EnterpriseAction';
import * as modalActions from '../../actions/ModalAction';
import { Category, Item } from '../../components/Detail';
import ModalWrapper from '../../components/modal/ModalWrapper';
import {
  BILLING_SYSTEM_REGISTER_FLAG_STATUS,
  ENTERPRISE_LAYER_L0,
  ENTERPRISE_LAYER_L1,
  NEW_PRICE_PLAN_RESERVATION,
  PRICE_PLAN,
} from '../../constants/EnterpriseConstants';
import * as FunctionConstants from '../../constants/FunctionConstants';
import * as ModalIds from '../../constants/ModalIds';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import { SHOW_MESSAGE } from '../../constants/actionTypes/message';
import { DEFAULT_DATE_FORMAT, LO_SUPER_USER, MODE, USAGE_SETTING } from '../../constants/index';
import * as utils from '../../utils';
import { canAccess } from '../../utils/AuthedUtils';
import {
  getBillingSystemRegisterFlagLabel,
  getBillingSystemTargetLabel,
  getCreditCheckedFlagLabel,
  getEnterpriseDeleteFlagLabel,
  getEnterprisePlanName,
  getLiveInititalCostStatus,
  getPaymentType,
  getServiceStopFlagLabel,
  getManualPasswordSettingFlag,
} from '../../utils/EnterPriseUtils';

let okBtnClick = false;
class EnterpriseDetailConfirm extends Component {
  constructor() {
    super();
    this.handleEditBtn = this.handleEditBtn.bind(this);
    this.handleOKBtn = this.handleOKBtn.bind(this);
    this.handleBackBtn = this.handleBackBtn.bind(this);
    // sprint_20230403 #14 START
    this.handlePreCancelBtn = this.handlePreCancelBtn.bind(this);
    // sprint_20230403 #14 END
  }

  handleEditBtn() {
    const { dispatch } = this.props;
    dispatch(modalActions.openModal(ModalIds.ENTERPRISE_EDIT));
  }

  // sprint_20230403 #14 START
  handlePreCancelBtn() {
    const { dispatch } = this.props;
    dispatch(modalActions.openModal(ModalIds.ENTERPRISE_REASON_FOR_CANCEL)); // sprint_20230522_tma
  }
  // sprint_20230403 #14 END

  handleOKBtn() {
    const { dispatch, editMode } = this.props;
    if (!okBtnClick) {
      okBtnClick = true;
      dispatch(enterpriseActions.saveEnterprise()).then(() => {
        okBtnClick = false;
        dispatch(modalActions.hideModal());
      }).catch((error) => {
        okBtnClick = false;
        const modalId = editMode === MODE.NEW_MODE ? ModalIds.ENTERPRISE_REGISTER : ModalIds.ENTERPRISE_EDIT;
        const messageInfo = {
          statusCd: error.statusCd,
          message: error.message,
          targetModal: true,
          messageType: 'danger',
        };
        dispatch(modalActions.openModal(modalId));
        dispatch({ type: SHOW_MESSAGE, ...messageInfo });
      });
    }
  }

  handleBackBtn() {
    const { dispatch, editMode } = this.props;
    const modalId = editMode === MODE.NEW_MODE ? ModalIds.ENTERPRISE_REGISTER : ModalIds.ENTERPRISE_EDIT;
    dispatch(modalActions.openModal(modalId));
  }

  getModalOptions() {
    // sprint_20230403 #14 START
    const {
      modalId,
      enterpriseCdLogin,
      editingEnterprise,
      userInfo: { displayUserType },
      // sprint_20230605_tma START
      editingEnterprise: { billingSystemRegisterFlag }, 
      readOnlyFlag,
      rootFlag, // Step 10.0.0
      // sprint_20230605_tma END
    } = this.props;
    // sprint_20230403 #14 END

    const enterpriseDetailOption = {
      title: '企業情報の詳細',
      footerBtns: [{ name: 'キャンセル', onClick: this.props.hideModal, variant: 'default' }],
    };

    // Step 12.0.0 TAS-18710 START
    // Step 13.0.0 TAS-21617 START
    if (
      (canAccess(FunctionConstants.ENTERPRISE_EDIT) && rootFlag) ||
       enterpriseCdLogin !== editingEnterprise.enterpriseCd ||
      (utils.isSuperUserL1(displayUserType) && rootFlag)
    ) {
    // Step 13.0.0 TAS-21617 END
      // Step 12.0.0 TAS-18710 END
      enterpriseDetailOption.footerBtns.push({
        name: "編集",
        onClick: this.handleEditBtn,
        variant: 'primary',
      });
    }

    // sprint_20230403 #14 START
    // sprint_20230508 #24 START
    // Step 10.0.0 START
    const isShowPreCancelBtn =
      ((utils.isSuperUserL0(displayUserType) && !readOnlyFlag) ||
        (utils.isSuperUserL1(displayUserType) && rootFlag && !readOnlyFlag)) &&
      editingEnterprise.enterpriseLayer === ENTERPRISE_LAYER_L1 &&
      !editingEnterprise.enterpriseDeleteFlag &&
      billingSystemRegisterFlag !== BILLING_SYSTEM_REGISTER_FLAG_STATUS.NOT_REGISTERED; // sprint_20230605_tma
    // Step 10.0.0 END
    if (isShowPreCancelBtn) {
      // sprint_20230508 #24 END
      enterpriseDetailOption.footerBtns.push({
        name: '解約の手続きに進む',
        onClick: this.handlePreCancelBtn,
        className: 'btn-proceedEnterpriseCancel btn-96 btn btn-default',
        variant: 'default'
      });
    }
    // sprint_20230403 #14 END

    const OPTIONS = {
      [ModalIds.ENTERPRISE_DETAIL]: enterpriseDetailOption,
      [ModalIds.ENTERPRISE_CONFIRM]: {
        title: '以下の内容で登録します。',
        footerBtns: [
          { name: 'キャンセル', onClick: this.handleBackBtn, variant: 'default' },
          { name: 'OK', onClick: this.handleOKBtn, variant: 'primary' },
        ],
      },
    };

    return OPTIONS[modalId];
  }

  render() {
    const { editingEnterprise, userInfo: { displayUserType }, orgPricePlan, isDetail, rootFlag, isEnterpriseNotChild } = this.props;
    const { usageSettingInfo, unitPriceSettingInfo } = editingEnterprise;
    const { pricePlan, pricePlanUpdateReservedFlag } = usageSettingInfo;
    const editMode = this.props.editMode ? this.props.editMode === MODE.EDIT_MODE : false;
    const isSettingPricePlanUpdateReservedFlag = pricePlanUpdateReservedFlag === undefined ? false : pricePlanUpdateReservedFlag;
    const enterprisePlanName = pricePlan === undefined ? getEnterprisePlanName(PRICE_PLAN.NEW) : getEnterprisePlanName(pricePlan);
    const isUsingNewPlan = pricePlan === undefined ? true : pricePlan === PRICE_PLAN.NEW;
    let isEnterpriseLayerL1 = null;
    let isShowNewPlanName = false;
    let isShowUsageSetting = false;
    let isShowTimeRateText = false;
    const isSuperUserL0 = displayUserType === LO_SUPER_USER;
    // STEP 10.0.0 START
    const isShowContractorInfo = isSuperUserL0 || rootFlag;
    // STEP 10.0.0 END

    if (isSuperUserL0) {
      if (editMode) {
        isEnterpriseLayerL1 = editingEnterprise.enterpriseLayer === ENTERPRISE_LAYER_L1;
        if (isEnterpriseLayerL1 && orgPricePlan !== PRICE_PLAN.NEW) { // 企業L1
          isShowUsageSetting = true;
          if (!isSettingPricePlanUpdateReservedFlag) {
            isShowNewPlanName = true;
          }
        } else { // 企業L2以下
          isShowNewPlanName = false;
          isShowUsageSetting = orgPricePlan === PRICE_PLAN.OLD;
        }
        // Check show ライブオプション利用料時間 in edit mode
        // #7182 START
        isShowTimeRateText = orgPricePlan === PRICE_PLAN.NEW;
        // #7182 END
      } else {
        const { parentEnterpriseInfo } = editingEnterprise;
        const { parentEnterpriseLayer, parentPricePlan, parentPricePlanUpdateReservedFlag } = parentEnterpriseInfo;
        isEnterpriseLayerL1 = parentEnterpriseLayer === ENTERPRISE_LAYER_L0;
        if (parentEnterpriseLayer === ENTERPRISE_LAYER_L0) { // 企業L1
          isShowNewPlanName = true;
          isShowUsageSetting = !isUsingNewPlan;
        } else { // 企業L2以下
          isShowNewPlanName = false;
          isShowUsageSetting = parentPricePlan === PRICE_PLAN.OLD;
        }

        //  Check show ライブオプション利用料時間 in new mode
        // #7182 START
        if (isEnterpriseLayerL1) {
          isShowTimeRateText = isUsingNewPlan;
        } else {
          isShowTimeRateText = parentPricePlan === PRICE_PLAN.NEW;
        }
        // #7182 END
      }
    }

    return (
      <ModalWrapper {...this.getModalOptions()} hideModal={this.props.hideModal}>
        <Form className='form-horizontal'>
          {/* sprint_20230418 #13 START */}
          {editMode && isDetail && (
            <Item name="企業ID" value={editingEnterprise.enterpriseId} labelSize={4} valueSize={8} />
          )}
          {/* sprint_20230418 #13 END */}
          <Item name="企業名" value={editingEnterprise.enterpriseName} labelSize={4} valueSize={8} />
          <Item name="企業コード" value={editingEnterprise.enterpriseCd} labelSize={4} valueSize={8} />
          {/* sprint_20230403 #4 START */}
          {editMode && (isSuperUserL0 || (!isSuperUserL0 && isDetail)) && (
            <Item name="利用開始日" value={utils.parseDateForDetail(editingEnterprise.enterpriseStartDate, DEFAULT_DATE_FORMAT)} labelSize={4} valueSize={8} />
          )}
          {/* sprint_20230403 #4 END */}

          {isSuperUserL0 &&
            <Item name="汎用請求番号" value={editingEnterprise.generalPurposeNumber} labelSize={4} valueSize={8} />}

          <Category label="利用機能設定" />
          <Item
            name="ビデオ"
            value={utils.getSettingUsageLabel(usageSettingInfo.usageSettingVideo)}
            indent={1}
            labelSize={4}
            valueSize={8}
          />
          {isSuperUserL0 &&
            unitPriceSettingInfo &&
            <>
              <Category label="単価設定" />
              {!isShowNewPlanName && isEnterpriseLayerL1 && isSettingPricePlanUpdateReservedFlag && (
                <Item name="料金プラン" value={NEW_PRICE_PLAN_RESERVATION} indent={1} labelSize={4} valueSize={8} />
                )
              }
              {!isShowNewPlanName && isEnterpriseLayerL1 && orgPricePlan === PRICE_PLAN.NEW && (
                <Item name="料金プラン" value={SELECT_BOX_DATA.ENTERPRISE_PRICE_PLAN[0].name} indent={1} labelSize={4} valueSize={8} />
              )}
              {isShowNewPlanName && isEnterpriseLayerL1 && (
                <Item name="料金プラン" value={enterprisePlanName} indent={1} labelSize={4} valueSize={8} />
                )
              }
              <Item name="ID単価" value={`${unitPriceSettingInfo.unitPriceSettingId || 0}円`} indent={1} labelSize={4} valueSize={8} />
              {isShowUsageSetting && (usageSettingInfo.usageSettingDrill === USAGE_SETTING.USE ||
                usageSettingInfo.usageSettingDocument === USAGE_SETTING.USE ||
                usageSettingInfo.usageSettingLrs === USAGE_SETTING.USE) &&
                <Item
                  name="学習プランストレージ加算料"
                  value={`${unitPriceSettingInfo.unitPriceSettingLmsStorage || 0}円`}
                  indent={1}
                  labelSize={4}
                  valueSize={8}
                />}
              {isShowUsageSetting && usageSettingInfo.usageSettingVideo === USAGE_SETTING.USE &&
                <Item
                  name="ビデオストレージ加算料"
                  value={`${unitPriceSettingInfo.unitPriceSettingVideoStorage || 0}円`}
                  indent={1}
                  labelSize={4}
                  valueSize={8}
                />}
              {isShowUsageSetting && usageSettingInfo.usageSettingVideo === USAGE_SETTING.USE &&
                <Item
                  name="ビデオオプション利用料"
                  value={`${unitPriceSettingInfo.unitPriceSettingVideoFlowRate || 0}円`}
                  indent={1}
                  labelSize={4}
                  valueSize={8}
                />}
            </>}
          <Item name="稼働状態" value={utils.getDormantStateLabel(editingEnterprise.dormantState)} labelSize={4} valueSize={8} disabled={isEnterpriseNotChild} />

          {/* sprint_20230403 #4 START */}
          {/* Step 10.0.0 START */}
          {editMode && isShowContractorInfo && (
            <>
              {/* display for both L0 and root_user */}
              <Category label="契約者情報" />
              {/* Step 12.0.0 TAS-18710 START */}
              <Item name="契約事業者名" value={editingEnterprise.subscriberName} indent={1} labelSize={5} valueSize={7} disabled={isEnterpriseNotChild} />
              <Item name="契約事業者の担当者名" value={editingEnterprise.subscriberContactPersonName} indent={1} labelSize={5} valueSize={7} disabled={isEnterpriseNotChild} />
              <Item name="契約事業者の電話番号" value={editingEnterprise.subscriberPhoneNumber} indent={1} labelSize={5} valueSize={7} disabled={isEnterpriseNotChild} />
              <Item name="契約事業者のメールアドレス" value={editingEnterprise.subscriberEmailAddress} indent={1} labelSize={5} valueSize={7} disabled={isEnterpriseNotChild} />
              <Item name="システム情報連絡先担当者名1" value={editingEnterprise.systemInfomationContactPersonName1} indent={1} labelSize={5} valueSize={7} disabled={isEnterpriseNotChild} />
              <Item name="システム情報連絡先担当者名2" value={editingEnterprise.systemInfomationContactPersonName2} indent={1} labelSize={5} valueSize={7} disabled={isEnterpriseNotChild} />
              <Item name="システム情報連絡先担当者名3" value={editingEnterprise.systemInfomationContactPersonName3} indent={1} labelSize={5} valueSize={7} disabled={isEnterpriseNotChild} />
              <Item name="システム情報連絡先メールアドレス1" value={editingEnterprise.systemInfomationContactEmailAddress1} indent={1} labelSize={5} valueSize={7} disabled={isEnterpriseNotChild} />
              <Item name="システム情報連絡先メールアドレス2" value={editingEnterprise.systemInfomationContactEmailAddress2 } indent={1 } labelSize = {5 } valueSize = {7 } disabled = {isEnterpriseNotChild } />
              <Item name="システム情報連絡先メールアドレス3" value = {editingEnterprise.systemInfomationContactEmailAddress3 } indent = {1 } labelSize = {5 } valueSize = {7 } disabled = {isEnterpriseNotChild } />
              {/* Step 12.0.0 TAS-18710 END */}
              {(isSuperUserL0 || (!isSuperUserL0 && isDetail)) && (
                <Item name="お客様ID" value={editingEnterprise.customerId} indent={1} labelSize={5} valueSize={7} />
              )}
              {/* sprint_20230418 #13 START */}
              {isDetail && (
                <Item name="契約企業コード" value={editingEnterprise.contractEnterpriseCd} indent={1} labelSize={5} valueSize={7} />
              )}
              {/* sprint_20230418 #13 END */}
              {/* display for L0 only */}
              {isSuperUserL0 && (
                <>
                  <Item name="担当者社員コード" value={editingEnterprise.contactPersonEmployeeCode} indent={1} labelSize={5} valueSize={7} />
                  <Item name="担当者社員名" value={editingEnterprise.contactPersonName} indent={1} labelSize={5} valueSize={7} />
                  <Item name="事業部名" value={editingEnterprise.divisionName} indent={1} labelSize={5} valueSize={7} />
                  <Item name="事業所名" value={editingEnterprise.officeName} indent={1} labelSize={5} valueSize={7} />
                  <Item name="部課名" value={editingEnterprise.departmentName} indent={1} labelSize={5} valueSize={7} />
                  <Item name="契約種別" value={editingEnterprise.contractCategory} indent={1} labelSize={5} valueSize={7} />
                  {/* sprint_20230731_tma START */}
                  <Item name="販売部門コード" value={editingEnterprise.saleCd} indent={1} labelSize={5} valueSize={7} />
                  {/* sprint_20230731_tma END */}
                  <Item name="チャネル区分" value={editingEnterprise.channelDivision} indent={1} labelSize={5} valueSize={7} />
                  <Item name="販売区分" value={editingEnterprise.saleDivision} indent={1} labelSize={5} valueSize={7} />
                  <Item name="備考/変更履歴" value={editingEnterprise.enterpriseRemark} indent={1} labelSize={5} valueSize={7} />
                </>
              )}
              {/* sprint_20230508 #24 START */}
              {isDetail && (
                <Item name="解約フラグ" value={getEnterpriseDeleteFlagLabel(editingEnterprise.enterpriseDeleteFlag)} indent={1} labelSize={5} valueSize={7} />
              )}
              {isDetail && (
                <Item name="解約予定日" value={utils.parseDateForDetail(editingEnterprise.enterpriseDeleteDate, DEFAULT_DATE_FORMAT)} indent={1} labelSize={5} valueSize={7} />
              )}
              {/* sprint_20230508 #24 END */}
              {/* display for L0 only */}
              {isSuperUserL0 && (
                <>
                  <Item name="IPアドレス制限利用" value={utils.getSettingUsageBooleanLabel(editingEnterprise.ipRestriction)} indent={1} labelSize={5} valueSize={7} />
                  <Item name="請求対象システム" value={getBillingSystemTargetLabel(editingEnterprise.billingSystemTarget)} indent={1} labelSize={5} valueSize={7} />
                  <Item name="与信審査" value={getCreditCheckedFlagLabel(editingEnterprise.creditCheckedFlag)} indent={1} labelSize={5} valueSize={7} />
                  <Item name="請求情報登録ステータス" value={getBillingSystemRegisterFlagLabel(editingEnterprise.billingSystemRegisterFlag)} indent={1} labelSize={5} valueSize={7} />
                  <Item name="スマートスタディサービス利用停止フラグ" value={getServiceStopFlagLabel(editingEnterprise.serviceStopFlag)} indent={1} labelSize={5} valueSize={7} className="text-nowrap" />
                  <Item name="支払い種別" value={getPaymentType(editingEnterprise.paymentType)} indent={1} labelSize={5} valueSize={7} /> {/* sprint_20230605_tma */}
                </>
              )}
              {/* STEP12.0.0 TAS-18710 START */}
              {(rootFlag || isDetail) && (
                <Item name="パスワード手動変更" value={getManualPasswordSettingFlag(editingEnterprise.manualPasswordSettingFlag)} indent={1} labelSize={5} valueSize={7} />
              )}
              {/* STEP12.0.0 TAS-18710 END */}
            </>
          )}
          {/* Step 10.0.0 END */}
          {/* sprint_20230403 #4 END */}
          {/* STEP12.0.0 TAS-18710 START */}
          {editMode && !isShowContractorInfo && isDetail && (
            <>
              <Category label="契約者情報" />
              <Item name="パスワード手動変更" value={getManualPasswordSettingFlag(editingEnterprise.manualPasswordSettingFlag)} indent={1} labelSize={4} valueSize={8} />
            </>
          )}
          {/* STEP12.0.0 TAS-18710 END */}
        </Form>
      </ModalWrapper>
    );
  }
}

EnterpriseDetailConfirm.propTypes = {
  dispatch: PropTypes.func.isRequired,
  editingEnterprise: PropTypes.shape().isRequired,
  editMode: PropTypes.number.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const { editingEnterprise, editMode, orgPricePlan, isDetail, isEnterpriseNotChild } = state.enterprise;
  const { userInfo, enterpriseCd, readOnlyFlag, rootFlag } = state.authed.authedUser;
  return {
    editingEnterprise,
    orgPricePlan,
    editMode,
    userInfo,
    enterpriseCdLogin: enterpriseCd,
    isDetail,
    readOnlyFlag, // sprint_20230605_tma
    rootFlag, // Step 10.0.0
    isEnterpriseNotChild, // Step 12.0.0 TAS-18710
  };
};
export default connect(mapStateToProps)(EnterpriseDetailConfirm);
